<template>
     <span class="hex" :style="{'width':width}">
         <span class="hexIn">
             <img v-if="imgUrl" :src="imgUrl" alt="">
             <img class="playerHead" v-else src="../assets/img/updateImg/playerHead.png" alt="">
         </span>
     </span>
</template>

<script>
    export default {
        name: "photoCard",
        props: {
            imgUrl: String,
            width: String,
            height: String,
            background: String,
            imgWidth: String,
            imgTop:String
        }
    }
</script>

<style scoped lang="less">
    .hex {
        overflow: hidden;
        display: inline-block;
        width: 7vw;
        height: 100%;
        /*background: red;*/
        /*transform: rotate(-75deg) skewY(60deg);*/
        color: #fff;
        text-align: center;
        img {
            width: 80%;
        }
    }

    .hexIn {
        display: inline-block;
        width: 100%;
        height: 100%;
        text-align: center;
        overflow: hidden;
        /*transform: skewY(-60deg) rotate(75deg);*/
        img {
            width: 100%;
            /*margin-left: -10%;*/
        }
        .playerHead{
            margin-top: 5%;
            width: 100%;
            margin-left: 0;
        }
    }
</style>
